import axios from "@/http"
export default {
  name:"webAuth",
  AddAuths(param){
    return axios({
      method:"POST",
      url:"/api/backstage/mechanism/mechanismApi/AddAuths",
      params:param
    })
  },
  QueryMechanismAuths(param){
    return axios({
      method:"GET",
      url:"/api/backstage/mechanism/mechanismApi/QueryMechanismAuths",
      params:param
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/axj-web/axj-web-auth-api.js